<template>
    <div class="card my-1">
        <div class="card-header text-white text-center app-class-summary-panel-headings">
            <h4>
                <strong>COMMODITY 1</strong>
            </h4>
        </div>
        <div class="card-body app-class-summary-panel-body">
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Name
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_1" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Beginning Stock
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Stock Received
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_3" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Distributed
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_4" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Expired
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_5" 
                                v-bind:prop_qst_show_bools_as_sym="false"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                End Stock
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_6" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                PerCommAcct
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_7" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Comparison
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_8" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Explain discrepancy
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_9" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentSummary1',

    props:[
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        data_qst_1:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodities_group/commodity1_name"];
        },
        data_qst_2:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/BeginStocks_1"];
        },
        data_qst_3:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/ReceiveStoc_1"];
        },
        data_qst_4:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/Distributed_1"];
        },
        data_qst_5:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/ComdExpired_1"];
        },
        data_qst_6:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/EntEndStock_1"];
        },
        data_qst_7:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/PerCommAcct_1"];
        },
        data_qst_8:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/ComparisonT_1"];
        },
        data_qst_9:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["VerifyHealt/commodity_ques_1/ExplDiscrep_1"];
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
